<template>
  <div class="choose-count-wrapper">
    <div class="reduce" @click="reduce">-</div>
    <input type="number" v-model="num" class="choose-count" @input = "customizeQuantity">
    <div class="plus" @click="add">+</div>
      <span class="right-JK" v-if="rightCount">请输入{{pro.min_num}}-{{pro.max_num == null? limit : pro.max_num}}范围内的数值</span>
  </div>
</template>
<script>
import {mapState} from 'vuex'
  export default {
    data(){
      return {
        rightCount: false,
        num: "",
        limit: 9999,
      }
    },
    watch:{
      //当使用快速选择康复天数时，动态修改康复天数的数值
      quantity(val){
        this.num = val;
      }
    },
    props:['pro'],
    computed:{
      ...mapState(["quantity"])
    },
    mounted() {
      this.num = this.quantity;
    },
    methods:{
      customizeQuantity(){
        if(this.pro.max_num == null){
          this.pro.max_num = this.limit;
        }
        if(parseInt(this.num) > this.pro.max_num || parseInt(this.num) < this.pro.min_num){
          this.rightCount = true;
          //输入不合格，禁用按钮
          this.$emit("setDisabled", true);
        }else{
          this.rightCount = false;
          this.$emit("setDisabled", false);
          this.$store.commit("changeQuantity", this.num);
        }
      },
      reduce(){
        this.num--;
        if(this.num < this.pro.min_num){
          this.num = this.pro.min_num;
        }
        this.$emit("setDisabled", false);
        this.$store.commit("changeQuantity", this.num);
      },
      add(){
        this.num++;
        if(this.pro.max_num != null && this.num > this.pro.max_num){
          this.num = this.pro.max_num;
        }else if(this.pro.max_num == null){
          this.pro.max_num = this.limit;
        }
        this.$emit("setDisabled", false);
        this.$store.commit("changeQuantity", this.num);
      },
    }
  }
</script>
<style scoped>
.choose-count-wrapper{
      position: relative;
      width: 260px;
      height: 40px;
	  padding: 0 20px 0 20px;
	  border:1px solid #ddd;
	  border-radius: 20px;
   }
  .choose-count{
	  text-align: center;
	  width: 120px;
	  height: 36px;
	  display: block;
	  margin: 0 auto;
	  outline:none;
	  border:0px;
  }
  .choose-count-wrapper .reduce,.choose-count-wrapper .plus{
	  position:absolute;
	  top:-8px;
	  width:28px;
	  color:#2196f3;
	  font-size:34px;
	  cursor: pointer;
  }
  .choose-count-wrapper .reduce{
	  left: 20px;
	  color: rgba(0, 0, 0, 0.6);
  }
  .choose-count-wrapper .plus{
	  right:10px;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    margin: 0;
 }
 .right-JK{
    position:absolute;
    left:340px;
    bottom:10px;
    width: 180px;
    font-size:14px;
    color:#E75710;
  }

</style>



// WEBPACK FOOTER //
// changeCount.vue?304fa84c